module.exports = __webpack_public_path__ + "img/warning.93bb2a09.svg";